export default function Build({ content }) {
  return (
    <section className="section section-build" id="build">
      <div className="section-inner">
        <div className="section-header wide-header">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2>{content.title}</h2>
          <p>{content.intro}</p>
        </div>

        <div className="build-grid">
          <article className="build-panel">
            <p className="panel-label">Commands</p>
            <h3>{content.commandTitle}</h3>
            <pre className="code-block">
              <code>
                {content.commands.map((line, index) => (
                  <span
                    className={line.startsWith('#') ? 'code-comment' : line === '' ? 'code-space' : 'code-line'}
                    key={`${line}-${index}`}
                  >
                    {line || ' '}
                    {'\n'}
                  </span>
                ))}
              </code>
            </pre>
          </article>

          <article className="build-panel">
            <p className="panel-label">Source</p>
            <h3>{content.treeTitle}</h3>
            <div className="source-tree">
              {content.tree.map(([path, note]) => (
                <div className="tree-row" key={path}>
                  <code>{path}</code>
                  <span>{note}</span>
                </div>
              ))}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
